import { render } from "./BulkUploadCsvFile.vue?vue&type=template&id=34fb23fb&scoped=true"
import script from "./BulkUploadCsvFile.vue?vue&type=script&lang=js"
export * from "./BulkUploadCsvFile.vue?vue&type=script&lang=js"

import "./BulkUploadCsvFile.vue?vue&type=style&index=0&id=34fb23fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fb23fb"]])

export default __exports__